import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import axios from "axios";
import config from "../includes/ConfigFile";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "../css/chapterDetails.css";

const StoryDetail = () => {
    const { storyId } = useParams();

    const [storyData,setstoryData] = useState([]);
    const [currentChapter, setCurrentChapter] = useState();
    const [firstChapter, setFirstChapter] = useState();
    const [storyTitle, setStoryTitle] = useState("");
    const [shortDescription, setShortDescription] = useState("");
    const [storyImage, setstoryImage] = useState("");
    const [story,setstory] = useState([]);
    const [writerName, setwriterName] = useState("");
    const [writerId, setWriterId] = useState("");

    //  Rating States
    const [rating, setRating] = useState(0);
    const [hoverRating, setHoverRating] = useState(0);
    const [avgRating, setAvgRating] = useState(0);
    const [totalRatings, setTotalRatings] = useState(0);

    const user = JSON.parse(localStorage.getItem("user"));
    //Share counting
    const increaseShare = () => {
        axios.get(`${config.BASE_URL}/api/share/${storyId}`)
        .then(res => console.log("Share Count Updated"))
        .catch(err => console.error(err));
    };

    // ================= SHARE LOGIC =================
    const shareUrl = `${window.location.origin}/story/${storyId}`;

    const handleShare = () => {
        increaseShare();// Increment share count on backend
        if (navigator.share) {
            navigator.share({
                title: storyTitle,
                text: shortDescription,
                url: shareUrl,
            });
        } else {
            navigator.clipboard.writeText(shareUrl);
            toast.success("Link copied! 📋");
        }
    };

    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(storyTitle + " " + shareUrl)}`;
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`;
    const twitterUrl = `https://twitter.com/intent/tweet?url=${shareUrl}&text=${storyTitle}`;
    // =================================================

    useEffect(() => {
        axios.get(`${config.BASE_URL}/api/getStoryRating/${storyId}`)
        .then(res => {
            setAvgRating(res.data.avg_rating || 0);
            setTotalRatings(res.data.total || 0);
        });
    }, [storyId]);

    // const handleRatingClick = (value) => {
    //     if (!isUserLoggedIn) {
    //         setShowLoginPopup(true);
    //         return;
    //     }

    //     setRating(value);

    //     axios.post(`${config.BASE_URL}/api/saveRating`, {
    //         user_id: user?.id,
    //         post_id: storyId,
    //         rating: value,
    //         type: "story"
    //     })
    //     .then(() => axios.get(`${config.BASE_URL}/api/getStoryRating/${storyId}`))
    //     .then(res => {
    //         setAvgRating(res.data.avg_rating);
    //         setTotalRatings(res.data.total);
    //     });
    // };

    const handleRatingClick = async (value) => {
        try {
            if (!isUserLoggedIn) {
                setShowLoginPopup(true);
                return;
            }

            setRating(value);

            //  SAVE RATING
            /* console.log({
                user_id: user?.id,
                post_id: storyId,
                rating: value,
                type: "story"
            }); */
           const response = await axios.post(`${config.BASE_URL}/api/saveRating`, {
                user_id: user?.id,
                post_id: storyId,
                rating: value,
                type: "story"
            }, {
                headers: {
                    "Content-Type": "application/json"
                }
            });
            if (response.data.action === "inserted") {
                toast.success("⭐ Thanks for your rating!");
            } else {
                toast.info("🔄 Rating updated!");
            }

            //  GET UPDATED RATING
            const res = await axios.get(`${config.BASE_URL}/api/getStoryRating/${storyId}`);

            setAvgRating(res.data.avg_rating);
            setTotalRatings(res.data.total);

        } catch (error) {
            console.log("Rating Error 👉", error.response || error);
        }
    };


    const isUserLoggedIn = localStorage.getItem("user") !== null;

    useEffect(() => {
        axios.get(`${config.BASE_URL}/api/GetPostsDetails/${storyId}`)
        .then(response => {
            setstoryData(response.data);
            setFirstChapter(response.data[0]?.id);
        });
    }, []);

    useEffect(() => {
        axios.get(`${config.BASE_URL}/api/GetPostDetailById/${storyId}`)
        .then(response => {
            const current = response.data[0];
            if (current) {
                setStoryTitle(current.post_title);
                setShortDescription(current.post_short_description);
                setstoryImage(current.post_image);
                setwriterName(current.author_name);
                setWriterId(current.user_id);
            }
        });
    }, []);

    const [showLoginPopup, setShowLoginPopup] = useState(false);

    return (
        <>
        <div className="py-5">
            <div className="container">
                <div className="row">
                    <div className="col-md-3">
                        <img src={`${config.BASE_URL}/public/uploads/admin/post/${storyImage}`} className="img-fluid rounded shadow" alt="" />
                    </div>

                    <div className="col-md-9">
                        <h2>{storyTitle}</h2>
                        <p>{shortDescription}</p>

                        <p>
                            Writer :-{" "}
                            <b>
                                <Link to={`/writerDetails/${writerId}`}>
                                    {writerName}
                                </Link>
                            </b>
                        </p>

                        <Link to={`/chapter/${firstChapter}/${storyId}`}>
                            <button className="btn btn-primary">अभी पढ़ें</button>
                        </Link>

                        {/* ⭐ RATING */}
                        <div className="mt-3">
                            <h6>⭐ Rating</h6>

                            {[1,2,3,4,5].map((star) => (
                                <i
                                    key={star}
                                    className={`bi ${star <= (hoverRating || rating) ? "bi-star-fill" : "bi-star"}`}
                                    style={{ color: "#FFD700", fontSize: "22px", cursor: "pointer", marginRight: "5px" }}
                                    onClick={() => handleRatingClick(star)}
                                    onMouseEnter={() => setHoverRating(star)}
                                    onMouseLeave={() => setHoverRating(0)}
                                ></i>
                            ))}

                            <div style={{ fontSize: "14px", color: "#aaa" }}>
                                ⭐ {avgRating} ({totalRatings} ratings)
                            </div>
                        </div>

                        {/* 🚀 SHARE */}
                        <div className="mt-3">
                            <h6>📤 Share</h6>
                            <div className="d-flex align-items-center flex-wrap gap-2">

                            <button className="btn btn-dark btn-sm me-2" onClick={handleShare}>
                                <i className="bi bi-share me-1"></i> Share
                            </button>
                            

                            <a href={whatsappUrl} title="Share with Whatsapp" target="_blank" onClick={increaseShare} className="share-icon-btn whatsapp">
                                <i className="bi bi-whatsapp me-1"></i>
                            </a>

                            <a href={facebookUrl} target="_blank" onClick={increaseShare} className="share-icon-btn facebook"
            title="Share on Facebook">
                              <i className="bi bi-facebook me-1"></i>
                            </a>

                            <a href={twitterUrl} target="_blank" onClick={increaseShare} className="share-icon-btn twitter"
            title="Share on Twitter">
                               <i className="bi bi-twitter-x me-1"></i>
                            </a>

                            <button className="share-icon-btn copy"
                            title="Copy Link"
                                onClick={() => {
                                    increaseShare();
                                    navigator.clipboard.writeText(shareUrl);
                                    toast.success("Link copied! 📋");
                                }}
                            >
                                <i className="bi bi-clipboard me-1"></i>
                            </button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            {/* Chapters */}
            <div className="container mt-5">
                <h2 className="border-bottom pb-2">Chapters</h2>

                <div className="row g-4">
                    {storyData.map((chapter, index) => (
                        <div key={chapter.id} className="col-md-6">
                            <Link style={{color:'#ffff', textDecoration: 'none'}} to={`/chapter/${chapter.id}/${chapter.tbl_post_id}`}>
                                <div className="p-4 border rounded">
                                    {index + 1}. {chapter.chapter_no}
                                </div>
                            </Link>
                        </div>
                    ))}
                </div>
            </div>

            {/* LOGIN POPUP */}
            {/* {showLoginPopup && (
                <div className="modal show d-block" style={{ background: "rgba(0,0,0,0.5)" }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 style={{ color: '#000' }}>Login Required</h5>
                                <button className="btn-close" onClick={() => setShowLoginPopup(false)}></button>
                            </div>
                            <div className="modal-body" style={{ color: '#000' }}>
                                Please login first
                            </div>
                            <div className="modal-footer">
                                <Link to="/signIn" className="btn btn-primary">Login</Link>
                            </div>
                        </div>
                    </div>
                </div>
            )} */}
                {/*Login modal popup */}
                {showLoginPopup && (
                <div 
                    className="modal fade show" 
                    style={{ display: "block", background: "rgba(0,0,0,0.6)", backdropFilter: "blur(4px)" }}
                >
                    <div className="modal-dialog modal-dialog-centered">
                        <div 
                            className="modal-content shadow-lg border-0" 
                            style={{ borderRadius: "12px", overflow: "hidden" }}
                        >

                            {/* HEADER */}
                            <div 
                                className="modal-header" 
                                style={{ background: "#f8f9fa" }}
                            >
                                <h5 className="modal-title fw-bold text-dark">
                                    🔐 Login Required
                                </h5>

                                <button 
                                    className="btn-close" 
                                    onClick={() => setShowLoginPopup(false)}
                                ></button>
                            </div>

                            {/* BODY */}
                            <div className="modal-body text-center py-4">
                                <p style={{ fontSize: "16px", color: "#555" }}>
                                    Please login to rate this chapter ⭐
                                </p>
                            </div>

                            {/* FOOTER */}
                            <div className="modal-footer justify-content-center gap-2 pb-4">

                                <button 
                                    className="btn btn-outline-secondary px-4"
                                    onClick={() => setShowLoginPopup(false)}
                                >
                                    Close
                                </button>

                                <button 
                                    className="btn btn-primary px-4"
                                    style={{
                                        background: "linear-gradient(135deg, #4facfe, #00f2fe)",
                                        border: "none"
                                    }}
                                    onClick={() => window.location.href = "/signIn"}
                                >
                                    Login
                                </button>

                            </div>

                        </div>
                    </div>
                </div>
            )}


        </div>
        {/* <ToastContainer position="top-right" autoClose={2000} /> */}
        
        </>
    );
    
};

export default StoryDetail;